export default {
  locales: ['ar', 'en'],
  lang:'ar',
  isRTL: true,
  language: {
    locale: 'ar',
    rtl: 'rtl',
    rtl2: 'rtl.',
    direction: 'right',
  },
  messages: 'success',
  loading: false,
  addedToCart: false,
};
